export const GUIDE = `우산 대여의 단위는 일 단위에요
ex. 1일 대여: 500원, 2일 대여: 990원, 3일 대여:`;
